// src/legal/PrivacyPolicy.jsx
import React, { useEffect } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <main className="min-h-screen bg-neutral-50">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
        {/* Header */}
        <div className="flex items-center justify-between gap-3 mb-6">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 rounded-full px-4 py-2 border border-gray-300 bg-white hover:bg-gray-50 text-sm"
          >
            <FiArrowLeft /> Geri
          </button>
          <div className="text-right text-xs text-gray-500">
            Son güncelleme: {new Date().toLocaleDateString("tr-TR")}
          </div>
        </div>

        <article className="rounded-2xl bg-white shadow-sm ring-1 ring-gray-100 p-5 sm:p-8 leading-relaxed text-gray-800">
          <header className="mb-6">
            <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight">
              KVKK GİZLİLİK POLİTİKASI VE İLKELER
            </h1>
          </header>

          <section className="space-y-4">
            <p>
              ARONTECH BİLGİ TEKNOLOJİLERİ A.Ş. (“<strong>ARON</strong>”) olarak{" "}
              <strong>https://zenolearn.io</strong> adresinde yer alan web
              sitemiz ve buna bağlı yönetim panelleri (“<em>Web Sitesi</em>”
              ve/veya “<em>Uygulama</em>”) üzerinden veya diğer kanallarla bize
              ilettiğiniz kişisel verilerinizin korunmasına önem veriyoruz. 6698
              sayılı <strong>Kişisel Verilerin Korunması Kanunu</strong> (“
              <strong>KVKK</strong>”) ve AB Genel Veri Koruma Tüzüğü (“
              <strong>GDPR</strong>”) uyarınca, kişisel verileriniz KVKK
              m.4’teki ilkelere ve m.5–6’daki işleme şartlarına uygun olarak
              işlenmektedir.
            </p>
            <p>
              Bu Politika; hangi verileri hangi amaçlarla işlediğimizi, toplama
              yöntem ve hukuki sebeplerimizi, aktarım süreçlerini ve veri sahibi
              haklarını açıklar. “Kişisel veri”, kimliği belirli/belirlenebilir
              gerçek kişiye ilişkin her türlü bilgiyi ifade eder. ARON, ilgili
              kişiler yönünden “<strong>veri sorumlusu</strong>” sıfatına
              sahiptir.
            </p>
          </section>

          <hr className="my-6" />

          <section id="madde-1" className="space-y-4">
            <h2 className="text-xl font-bold">
              MADDE 1 — VERİ TOPLAMA ESASLARI ve AYDINLATMA YÜKÜMLÜLÜĞÜ
            </h2>

            <h3 className="font-semibold">
              1.1. Kişisel Verileri Toplama Yöntemi
            </h3>
            <p>
              Veriler; şirket merkezimiz, telefon, e-posta, web sitemiz, sosyal
              medya alanlarımız, iş ilişkisi içinde olduğumuz üçüncü kişiler,
              seminer/organizasyon/fuar gibi etkinlikler dâhil olmak üzere
              otomatik ya da otomatik olmayan yöntemlerle; sözlü, yazılı veya
              elektronik şekilde elde edilebilir. Hizmetlerden yararlandığınız
              sürece verileriniz işlenebilir ve doğruluk/güncelliğin sağlanması
              amacıyla güncellenebilir.
            </p>

            <h3 className="font-semibold">1.2. Amaç ve Kaynaklar</h3>
            <h4 className="font-medium">
              1.2.1. Kişisel verileriniz şu amaçlarla işlenir:
            </h4>
            <ul className="list-disc pl-6 space-y-1">
              <li>
                Ürün ve hizmetler hakkında gerektiğinde tanıtım ve bilgilendirme
                yapılabilmesi,
              </li>
              <li>Ürün ve hizmetlerin tarafınıza ulaştırılabilmesi,</li>
              <li>İş ve işlem kayıtlarının güvenliğinin sağlanması,</li>
              <li>
                ARON’un ticari planlama ve tanıtım faaliyetlerinin belirlenmesi.
              </li>
            </ul>

            <h4 className="font-medium">1.2.2. Verilerin Dayanağı</h4>
            <ul className="list-disc pl-6 space-y-1">
              <li>
                <strong>Açık rıza:</strong> Veri sahibinin bilgilendirilmiş
                özgür iradesiyle verdiği açık rıza kapsamında ve yalnızca rıza
                kapsamındaki amaçlarla işleme.
              </li>
              <li>
                <strong>Yasal düzenlemeler:</strong> Kanunun açıkça öngördüğü
                hâllerde, ilgili mevzuatla sınırlı olmak üzere işleme.
              </li>
              <li>
                <strong>Fiilî imkânsızlık:</strong> Rıza veremeyecek durumda
                olan kişinin veya bir başkasının hayatı/beden bütünlüğünün
                korunması için zorunluluk hâlinde işleme.
              </li>
              <li>
                <strong>Sözleşme:</strong> Bir sözleşmenin kurulması veya
                ifasıyla doğrudan ilgili ve gerekli olması hâlinde işleme.
              </li>
              <li>
                <strong>Yasal yükümlülük:</strong> Veri sorumlusu olarak hukuki
                yükümlülüklerimizi yerine getirmek amacıyla işleme.
              </li>
              <li>
                <strong>Alenileştirme:</strong> Veri sahibince alenileştirilen
                verilerin, alenileştirme amacıyla sınırlı şekilde işlenmesi.
              </li>
              <li>
                <strong>Hakların tesisi/korunması:</strong> Bir hakkın tesisi,
                kullanılması veya korunması için zorunlu olması hâlinde işleme.
              </li>
              <li>
                <strong>Meşru menfaat:</strong> Temel hak ve özgürlüklere zarar
                vermemek kaydıyla veri sorumlusunun meşru menfaatleri için
                zorunlu olan işleme.
              </li>
            </ul>

            <h3 className="font-semibold">
              1.3. Özel Nitelikli Kişisel Veriler
            </h3>
            <p>
              KVKK m.6 kapsamındaki özel nitelikli kişisel veriler (ırk, etnik
              köken, siyasi düşünce, felsefi inanç, din/mezhep, kılık-kıyafet,
              dernek/vakıf/sendika üyeliği, sağlık, cinsel hayat, ceza
              mahkûmiyeti ve güvenlik tedbirleriyle ilgili veriler, biyometrik
              ve genetik veriler) işlenmeyecektir.
            </p>
          </section>

          <hr className="my-6" />

          <section id="madde-2" className="space-y-3">
            <h2 className="text-xl font-bold">
              MADDE 2 — VERİLERİN AKTARILMASI
            </h2>
            <p>
              KVKK m.8 ve m.9 çerçevesinde; kişisel verileriniz, bu
              Politika’daki amaçların yerine getirilmesi için ticari ilişki
              içinde olunan kuruluşlara, kamu kurum ve kuruluşlarına, hizmet
              aldığımız üçüncü kişilere ve gerekli hâllerde yurt dışına
              aktarılabilir. Web sitesine üye olarak bu aktarıma onay vermiş
              sayılırsınız.
            </p>
          </section>

          <hr className="my-6" />

          <section id="madde-3" className="space-y-3">
            <h2 className="text-xl font-bold">MADDE 3 — VERİ GÜVENLİĞİ</h2>
            <p>
              KVKK m.12 uyarınca; kişisel verilerin hukuka aykırı işlenmesini ve
              erişimini önlemek, verileri muhafaza etmek için gerekli idari ve
              teknik tedbirleri alırız. Üçüncü kişilerce hukuka aykırı erişimi
              engellemeye yönelik önlemler uygulanır.
            </p>
          </section>

          <hr className="my-6" />

          <section id="madde-4" className="space-y-3">
            <h2 className="text-xl font-bold">
              MADDE 4 — VERİ SAHİBİNİN HAKLARI
            </h2>
            <p>
              KVKK m.11 uyarınca veri sahipleri, veri sorumlusuna başvurarak
              aşağıdaki haklara sahiptir:
            </p>
            <ol className="list-[lower-alpha] pl-6 space-y-1">
              <li>Kişisel veri işlenip işlenmediğini öğrenme,</li>
              <li>İşlenmişse buna ilişkin bilgi talep etme,</li>
              <li>
                İşleme amacını ve amacına uygun kullanılıp kullanılmadığını
                öğrenme,
              </li>
              <li>
                Yurt içinde/yurt dışında aktarıldığı üçüncü kişileri bilme,
              </li>
              <li>Eksik veya yanlış işlenmişse düzeltilmesini isteme,</li>
              <li>
                İşlenmesini gerektiren sebeplerin ortadan kalkması hâlinde
                silinmesini/yok edilmesini isteme ve yapılan işlemlerin
                aktarıldığı üçüncü kişilere bildirilmesini talep etme,
              </li>
              <li>
                Münhasıran otomatik sistemler vasıtasıyla analiz edilen verilere
                itiraz etme,
              </li>
              <li>
                Kanuna aykırı işlenme nedeniyle zarara uğraması hâlinde zararın
                giderilmesini talep etme.
              </li>
            </ol>
            <p className="text-sm text-gray-600">
              Not: Bilgilerin doğruluğu ve güncelliği veri sahibinin
              sorumluluğundadır.
            </p>
          </section>

          <hr className="my-6" />

          <section id="madde-5" className="space-y-3">
            <h2 className="text-xl font-bold">
              MADDE 5 — VERİLERİN SİLİNMESİ, YOK EDİLMESİ veya ANONİM HÂLE
              GETİRİLMESİ
            </h2>
            <p>
              KVKK m.7, ilgili Yönetmelik ve TCK m.138 uyarınca; işleme
              sebebinin ortadan kalkması veya amacın sona ermesi hâlinde kişisel
              veriler, mevzuattaki süreler içinde re’sen veya talep üzerine
              silinir, yok edilir ya da anonim hâle getirilir.
            </p>
          </section>

          <hr className="my-6" />

          <section id="madde-6" className="space-y-3">
            <h2 className="text-xl font-bold">
              MADDE 6 — KAYIT ve DEĞİŞİKLİKLER
            </h2>
            <p>
              KVKK m.16 kapsamında ARON için VERBİS’e kayıt zorunluluğu doğması
              hâlinde, veri sorumlusu/veri işleyen bilgileri sisteme kaydedilir
              ve ilgililerce görüntülenebilir. ARON, bu Politikayı her zaman
              güncelleyebilir; değişiklikler yeni sürümün yayımlanmasıyla
              yürürlüğe girer ve gerekli bilgilendirmeler web sitemiz üzerinden
              yapılır.
            </p>
          </section>

          <footer className="mt-10 pt-6 border-t border-gray-100 text-sm text-gray-600">
            <p>
              KVKK kapsamındaki talepleriniz için{" "}
              <a
                href="mailto:info@zenolearn.io"
                className="text-emerald-600 underline"
              >
                info@zenolearn.io
              </a>{" "}
              adresine yazabilirsiniz.
            </p>
            <div className="mt-3 flex flex-wrap gap-3 text-sm">
              <Link to="/legal/terms" className="underline text-gray-700">
                Kullanım Koşulları
              </Link>
              <span className="opacity-40">•</span>
              <Link
                to="/legal/clarification"
                className="underline text-gray-700"
              >
                Aydınlatma Metni
              </Link>
            </div>
          </footer>
        </article>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
